<template>
  <b-modal title="Formulario actualización" id="form_historical">
    <b-form class="row" data-vv-scope="form_decret_update">

      <b-form-group class="col-12 mt-2">
        <label class="mb-3" style="display: block">TIPO DE PRODUCTO</label>
        <b-form-checkbox v-model="payload.is_imported" class="pull-left">
          Importado
        </b-form-checkbox>
        <b-form-checkbox v-model="payload.is_made" class="pull-left ml-4">
          Fabricado
        </b-form-checkbox>
      </b-form-group>


      <b-form-group label="AÑO IMPORTACION" class="col-12 mt-2">
        <el-date-picker
            disabled
            style="width: 100%"
            v-model="payload.year_import"
            type="year"
            format="yyyy">
        </el-date-picker>
      </b-form-group>


      <b-form-group label="UNDE MEDIDA" class="col-6 mt-2">
        <el-select
            size="small"
            v-model="payload.mesure_unit_id"
            remote
        >
          <el-option
              v-for="item in unitMeasures.listas"
              :key="item.id"
              :label="item.lista"
              :value="item.id"
          />
        </el-select>
      </b-form-group>


      <!--Cantidad-->
      <b-form-group label="CANTIDAD" class="col-6 mt-2">
        <b-form-input v-model="payload.quantity"
                      :disabled="!payload.mesure_unit_id"
                      v-validate="'required|min_value:1'"
                      type="number"
                      name="cantidad"
                      @input="calculateKg({mesure_unit_id: payload.mesure_unit_id,quantity :payload.quantity,density: payload.density})"
                      step="0.0001">
        </b-form-input>
        <span class="text-danger span-error small"
              v-text="errors.first('form_decret_update.cantidad')"/>
      </b-form-group>



      <!--Densidad-->
      <b-form-group label="DENSIDAD" class="col-6 mt-2">
        <b-form-input v-model="payload.density"
                      id="densidad"
                      name="densidad"
                      :disabled="!withDensity.includes(payload.mesure_unit_id)"
                      v-validate="{ required: withDensity.includes(payload.mesure_unit_id) }"
                      type="number"
                      step="0.0001">
        </b-form-input>
        <span class="text-danger span-error small"
              v-text="errors.first('form_decret_update.densidad')"/>
      </b-form-group>

      <!--Unidades densidad-->
      <b-form-group label="UNDE DENSIDAD" class="col-6 mt-2">
        <el-select
            size="small"
            v-model="payload.density_unit_id"
            data-vv-as=" "
            remote
            disabled
        >
          <el-option
              v-for="item in densityUnits.listas"
              :key="item.id"
              :label="item.lista"
              :value="item.id"
          />
        </el-select>
      </b-form-group>


      <b-form-group label="CANTIDAD COMPRADA KG" class="col-12 mt-2">
        <b-form-input v-model="payload.quantity_purchased_kg"
                      name="cantidad"
                      disabled
                      v-validate="'required|min_value:1'"
                      min="1"
                      type="number"
                      step="0.0001">
        </b-form-input>
        <span class="text-danger span-error small"
              v-text="errors.first('form_decret_update.cantidad')"/>
      </b-form-group>
    </b-form>

    <template #modal-footer="{ ok, cancel, hide }">
      <b-button variant="outline-danger" @click="cancel()"> Cancelar</b-button>
      <b-button variant="primary" @click="save()"> Actualizar</b-button>
    </template>

  </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Swal from "sweetalert2";

export default {
  name: "ModalFormHistorical",
  props: ['payload'],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() < 2022;
        },
      }
    }
  },
  async created() {
    await this.getUnitMeasures()
    await this.getDensityUnits()
  },
  methods: {
    ...mapActions('decret_1630', ['updateDcrHistoricalImports','getDcrHistoricalImports']),
    ...mapActions("accidents_high", ["getUnitMeasures", "getDensityUnits"]),
    ...mapMutations("decret_1630", ["calculateKg"]),
    async save() {
      const isValid = await this.validateData();
      if (isValid){
        let payload = clone(this.payload);
        payload.year_import = new Date(this.payload.year_import).getFullYear();
        await this.updateDcrHistoricalImports(payload).then(async () => {
          this.$bvModal.hide('form_historical');
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Información actualizada correctamente.',
            showConfirmButton: false,
            timer: 2000
          });
          await this.getDcrHistoricalImports({prod_products_id: this.payload.prod_products_id, company_id: this.payload.company_id})
        });
      }
    },
    async validateData() {
      const data = await this.$validator
          .validateAll('form_decret_update')
          .then(async (result) => {
            if (!result) return false;
            return true;
          });
      return data;
    },
  },
  computed: {
    ...mapState("accidents_high", ["unitMeasures", "densityUnits"]),
    ...mapState("decret_1630", ['withDensity', 'quantity_purchased_kg']),
  },
  watch: {
    'quantity_purchased_kg' : function (val) {
      this.payload.quantity_purchased_kg = val;
    },
    'payload.density' : function (val) {
      this.calculateKg({mesure_unit_id: this.payload.mesure_unit_id,quantity :this.payload.quantity, density: val})
    },
    'payload.mesure_unit_id' : function (val) {
      this.calculateKg({mesure_unit_id: val, quantity :this.payload.quantity, density: this.payload.density});
      if (val === 191){
        this.payload.density_unit_id = 197
      } else if (val === 190){
        this.payload.density_unit_id = 196
      } else if (val === 902){
        this.payload.density_unit_id = 196
      } else if (val === 193){
        this.payload.density_unit_id = 194
      } else {
        this.payload.density_unit_id = null
        this.payload.density = null
      }
    }
  }
}
</script>

<style scoped>

</style>
